import React, {Component} from 'react'

class Help002 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />保存した見積書を印刷する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[2-1]</span>画面上部のメニューの中の「印刷」ボタン(図2-1 参照)を押してください。</legend>
              <figcaption>図2-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_2-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[2-2]</span>メッセージが表示されるので「OK」ボタンを押してください。(図2-2 参照)</legend>
              <figcaption>図2-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_2-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[2-3]</span>画面の中の「御見積書」の内容を確認後、マウスで右クリック(図2-3-1 参照)し、ブラウザの印刷機能で印刷してください。(図2-3-2 参照)</legend>
              <figcaption>図2-3-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_2-3-1.png' /></li>
              </ul>
              <figcaption>図2-3-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_2-3-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[2-4]</span>印刷された「御見積書」をプリンターから取り出してください。</legend>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help002



// WEBPACK FOOTER //
// ./src/help/Help002.js